/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import swal from 'sweetalert';

export default function InsertAlert (msg){
   
    swal({
        title: msg,
        icon: "success",
        button: "Acceptar",
        timer: "4000"
    });
    
   
  }